// extracted by mini-css-extract-plugin
export var logo = "_k0-2";
export var logoWrapper = "_k0-1";
export var strip = "_k0-0";